export default {
  chart: {
    margin: 0,
    marginBottom: 0,
    style: {
      overflow: 'visible'
    },
  },
  credits: {
    enabled: false,
  },
  lang: {
    noData: ''
  },
  xAxis: {
    labels: {
      enabled: false,
    },
    title: {
      text: null,
    },
    startOnTick: false,
    endOnTick: false,
    tickPositions: [],
  },
  yAxis: {
    visible: false,
    endOnTick: false,
    startOnTick: false,
    labels: {
      enabled: false,
    },
    title: {
      text: null,
    },
    tickPositions: [0],
  },
  legend: {
    enabled: false,
  },
  rangeSelector: {
    enabled: false,
  },
  tooltip: {
    hideDelay: 0,
    outside: true,
    shared: true,
    valueDecimals: 2,
  },
}
